import { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  updateSelectedAccount,
  updateCurrentAccountInDB,
} from "modules/account/api/actions";
import { setSnackbar } from "modules/snackbar/api/snackbar";

export function useAccountToggle() {
  const dispatch = useDispatch();
  const account = useSelector((state) => state.account);

  const toggleField = useCallback(
    (fieldName, value) => {
      const updatedAccount = { ...account.data.account, [fieldName]: value };
      const updatedData = { ...account.data, account: updatedAccount };
      dispatch(updateSelectedAccount(updatedData));
      dispatch(setSnackbar(true, "warning", "Saving Account Detail Changes"));
      return dispatch(updateCurrentAccountInDB(updatedAccount)).then(() => {
        dispatch(setSnackbar(true, "success", "Saving Successful"));
      });
    },
    [account.data, dispatch]
  );

  return toggleField;
}
